namespace $.$$ {

	export class $shm_service_task_menu extends $.$shm_service_task_menu {
	}

}
